import { z } from "zod";
import { sizeUnits } from "../../units";
import { ZodNumberPositiveNullable } from "../zod-types/zod-number-nullable";

export const sizeFormSchema = z
	.object({
		width: ZodNumberPositiveNullable,
		height: ZodNumberPositiveNullable,
		depth: ZodNumberPositiveNullable,
		sizeUnit: z
			.preprocess((val) => {
				if (!val) return null;
				return val;
			}, z.enum(sizeUnits).default("meters").nullish())
			.nullish(),
	})
	.superRefine((values, context) => {
		if (values.width || values.height || values.depth) {
			if (!values.sizeUnit) {
				context.addIssue({
					code: "custom",
					message: "Size unit is required",
					path: ["sizeUnit"],
				});
			}
		}
	})
	.transform((values) => {
		if (!values.depth && !values.height && !values.width) {
			values.sizeUnit = null;
		}
		return values;
	});

export type SizeFormSchema = z.infer<typeof sizeFormSchema>;
export const sizeNumberFields = ["width", "height", "depth"] as const;
export const sizeUnitField = "sizeUnit" as const;
export type SizeNumberField = (typeof sizeNumberFields)[number];
export type SizeUnitField = typeof sizeUnitField;
